import greetingsResource from "../resources/GreetingsResource";

class GreetingsDictionary {
  constructor(private _resource) {
  }

  get() {
    return this._resource.get()
      .then((response) => this._processResponse(response))
      .then((data) => {
        return data.data;
      })
      .catch(async (error) => {
        console.log(error)
        throw new Error('Load error');
      });
  }

  async _processResponse(response) {
    const responseJson = response && await response.json();
    if (!responseJson) {
      return;
    }

    return responseJson;
  }
}

const greetingsDictionary = new GreetingsDictionary(greetingsResource);

export default greetingsDictionary;


// WEBPACK FOOTER //
// ./src/app/modules/stickers/domain/dictionaries/GreetingsDictionary.ts